import 'css-chunkapp/javascript/shared/components/Loader/Loader.module.scss';export default {
  "bg-black": "Loader-module__bg-black___BExi4",
  "tc-black": "Loader-module__tc-black___Jemy6",
  "bg-white": "Loader-module__bg-white___YnYbE",
  "tc-white": "Loader-module__tc-white___E-Wzy",
  "bg-blue": "Loader-module__bg-blue___xMI9T",
  "tc-blue": "Loader-module__tc-blue___cQnuc",
  "bg-grey1": "Loader-module__bg-grey1___QFPSi",
  "tc-grey1": "Loader-module__tc-grey1___eNmor",
  "bg-grey2": "Loader-module__bg-grey2___lBQtc",
  "tc-grey2": "Loader-module__tc-grey2___LFuNi",
  "bg-grey3": "Loader-module__bg-grey3___Ki0a2",
  "tc-grey3": "Loader-module__tc-grey3___FhFMF",
  "bg-grey4": "Loader-module__bg-grey4___ZnCU4",
  "tc-grey4": "Loader-module__tc-grey4___ClN8P",
  "bg-orange": "Loader-module__bg-orange___O-Izf",
  "tc-orange": "Loader-module__tc-orange___EPofv",
  "bg-pink": "Loader-module__bg-pink___4uJS5",
  "tc-pink": "Loader-module__tc-pink___Hyv1g",
  "bg-purple": "Loader-module__bg-purple___FiSqR",
  "tc-purple": "Loader-module__tc-purple___FXric",
  "bg-green": "Loader-module__bg-green___Bg-Ai",
  "tc-green": "Loader-module__tc-green___dNAU8",
  "bg-green-2": "Loader-module__bg-green-2___eSjL3",
  "tc-green-2": "Loader-module__tc-green-2___is9Ur",
  "bg-red": "Loader-module__bg-red___umS-r",
  "tc-red": "Loader-module__tc-red___Arhiy",
  "bg-red-2": "Loader-module__bg-red-2___U01tv",
  "tc-red-2": "Loader-module__tc-red-2___8pdt3",
  "bg-yellow": "Loader-module__bg-yellow___qvGA4",
  "tc-yellow": "Loader-module__tc-yellow___0vYKa",
  "bg-yellow-2": "Loader-module__bg-yellow-2___srt56",
  "tc-yellow-2": "Loader-module__tc-yellow-2___CuHRp",
  "bg-blue-4": "Loader-module__bg-blue-4___fkpl6",
  "tc-blue-4": "Loader-module__tc-blue-4___n7S4J",
  "bg-blue-5": "Loader-module__bg-blue-5___x0Ujv",
  "tc-blue-5": "Loader-module__tc-blue-5___R-J83",
  "bg-blue-6": "Loader-module__bg-blue-6___Lopq4",
  "tc-blue-6": "Loader-module__tc-blue-6___0EqJJ",
  "Loader": "Loader-module__Loader___Pk0Bg",
  "error": "Loader-module__error___3JSuP",
  "icon": "Loader-module__icon___Nh6xp",
  "spinner": "Loader-module__spinner___EI-sr",
  "rotation": "Loader-module__rotation___eKtT8"
};